import React, { useEffect, useState, useRef } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { auth, db } from "../firebase";
import "./Streak.css";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function getToday() {
  const now = new Date();
  return now.toISOString().slice(0, 10);
}

function getYesterday(dateStr) {
  const d = new Date(dateStr);
  d.setDate(d.getDate() - 1);
  return d.toISOString().slice(0, 10);
}

const Streak = () => {
  const [streak, setStreak] = useState(0);
  const [lastDay, setLastDay] = useState(null);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const timeoutRef = useRef();
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(u => {
      setUser(u);
    });
    return () => unsubscribe();
  }, []);

  // Función para comprobar la racha a las 23:59
  const checkStreak = async () => {
    if (!user) return;
    const today = getToday();
    const yesterday = getYesterday(today);

    // Recupera la racha guardada en localStorage
    let streakData = JSON.parse(localStorage.getItem("pomtask_streak")) || { streak: 0, lastDay: null };
    let nuevaRacha = streakData.streak;
    let ultimoDia = streakData.lastDay;

    // Si ya se ha comprobado hoy, no hacer nada
    if (ultimoDia === today) {
      setStreak(nuevaRacha);
      setLastDay(ultimoDia);
      setLoading(false);
      return;
    }

    // Si el último día registrado es ayer, revisa las tareas de ayer
    let diaAComprobar = yesterday;
    if (ultimoDia !== yesterday) {
      // Si la última vez que se comprobó fue hace más de un día, reinicia la racha
      nuevaRacha = 0;
      ultimoDia = today;
      // Guarda y actualiza
      localStorage.setItem("pomtask_streak", JSON.stringify({ streak: nuevaRacha, lastDay: ultimoDia }));
      setStreak(nuevaRacha);
      setLastDay(ultimoDia);
      setLoading(false);
      return;
    }

    // Obtiene todas las tareas del usuario para el día a comprobar (ayer)
    const q = query(
      collection(db, "scheduledTasks"),
      where("userId", "==", user.uid),
      where("date", "==", diaAComprobar)
    );
    const snapshot = await getDocs(q);

    let completadas = 0;
    let total = 0;
    snapshot.forEach(doc => {
      const t = doc.data();
      if (t.completedLate) return; // Ignora tareas completadas fuera de fecha
      total++;
      if (t.completed) completadas++;
    });

    // Si no hay tareas ese día, no cambia la racha
    if (total === 0) {
      setStreak(nuevaRacha);
      setLastDay(ultimoDia);
      setLoading(false);
      return;
    }

    // Calcula porcentaje completado
    const porcentaje = completadas / total;
    if (porcentaje >= 0.5) {
      nuevaRacha = nuevaRacha + 1;
    } else {
      nuevaRacha = 0;
    }
    ultimoDia = today;

    // Guarda y actualiza
    localStorage.setItem("pomtask_streak", JSON.stringify({ streak: nuevaRacha, lastDay: ultimoDia }));
    setStreak(nuevaRacha);
    setLastDay(ultimoDia);
    setLoading(false);
  };

  // Programa la comprobación a las 23:59
  useEffect(() => {
    if (!user) return;

    // Limpia cualquier timeout anterior
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    // Comprobación inicial para mostrar la racha actual y sumar si corresponde
    checkStreak();

    // Programa la comprobación a las 23:59
    const now = new Date();
    const nextCheck = new Date(now);
    nextCheck.setHours(23, 59, 0, 0);
    if (now > nextCheck) {
      nextCheck.setDate(nextCheck.getDate() + 1);
    }
    const msUntilCheck = nextCheck - now;

    timeoutRef.current = setTimeout(() => {
      checkStreak();
      setTimeout(checkStreak, 24 * 60 * 60 * 1000);
    }, msUntilCheck);

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
    // eslint-disable-next-line
  }, [user]);

  if (loading) return null;

  return (
    <div style={{
      background: "#fff",
      borderRadius: 12,
      padding: "1rem 2rem",
      margin: "1rem 0",
      boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
      textAlign: "center",
      position: "relative"
    }}>
      <span role="img" aria-label="fuego" style={{ fontSize: 28, marginRight: 8 }}>🔥</span>
      <span
        style={{
          color: "#339cff",
          cursor: "pointer",
          marginRight: 8,
          verticalAlign: "middle",
          position: "relative"
        }}
        title="La racha sube si completas al menos el 50% de tus tareas del día. Se comprueba cada noche a las 23:59."
        onClick={() => setShowTooltip((v) => !v)}
      >
        <FontAwesomeIcon icon={faInfoCircle} />
        {showTooltip && (
          <span
            style={{
              position: "absolute",
              left: "110%",
              top: "50%",
              transform: "translateY(-50%)",
              background: "#222",
              color: "#fff",
              padding: "8px 14px",
              borderRadius: 8,
              fontSize: 14,
              whiteSpace: "pre-line",
              zIndex: 10,
              minWidth: 220,
              boxShadow: "0 2px 8px rgba(0,0,0,0.18)"
            }}
          >
            La racha sube si completas al menos el 25% de tus tareas del día.
            {"\n"}Se comprueba cada noche a las 23:59.
          </span>
        )}
      </span>
      <span id="text-racha" style={{ fontWeight: "bold", fontSize: 22 }}>
        Racha: {streak} día{streak === 1 ? "" : "s"}
      </span>
    </div>
  );
};

export default Streak;